import { ApiReactiveService, type ApiServiceUseFetchOptions } from '@composable-api/service/api.reactive-service'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { CartCustomerAddressModel } from '@simploshop-models/cart-customer-address.model'

class CartCustomerAddressesApiService<M extends CartCustomerAddressModel> extends ApiReactiveService<M> {
    useGet<T extends boolean>(options?: ApiServiceUseFetchOptions<M, T>) {
        return this.useFetch({
            ...options,
            method: 'GET',
        })
    }
}

export function useCartCustomerAddressesApiService(options: {
    cartId: MaybeRefOrGetter<string | null | undefined>
}) {
    return new CartCustomerAddressesApiService({
        endpoint: () => `/carts/${toValue(options.cartId)}/customer-addresses`,
    }, CartCustomerAddressModel)
}
